/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { MerchantDetailsParentComponent } from "../merchant-details-parent.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService } from "../../../services";
import { Merchant, QBPayAccountDetails } from "../../../models";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-qbpay-details",
  templateUrl: "./qbpay-details.component.html"
})
export class QBPayDetailsComponent extends MerchantDetailsParentComponent implements OnInit {
  qbPayGroup!: FormGroup;
  actionInProgress = false;
  editable = false;
  buttonName = "Update QBPay Account Details";
  @Input("loaded") loaded = false;
  @Input("merchant") merchant!: Merchant;
  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private fb: FormBuilder
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.qbPayGroup = this.fb.group({
      refreshToken: [this.merchant.accountDetails.qbPayAccountDetails.qbpayRefreshToken, Validators.required]
    });
  }

  updateQBPayDetails() {
    if (this.qbPayGroup.valid) {
      this.actionInProgress = true;
      const tempQBPayAccountDetails: QBPayAccountDetails = JSON.parse(
        JSON.stringify(this.merchant.accountDetails.qbPayAccountDetails)
      );
      tempQBPayAccountDetails.qbpayRefreshToken = this.qbPayGroup.controls.refreshToken.value;
      this.merchantService.updateQBPayAccountDetails(this.merchant.id, tempQBPayAccountDetails).subscribe(
        () => {
          this.merchant.accountDetails.qbPayAccountDetails = tempQBPayAccountDetails;
          this.actionInProgress = false;
          this.editable = false;
        },
        (error) => {
          this.notificationService.error(error.error);
          this.actionInProgress = false;
        }
      );
    } else {
      this.qbPayGroup.markAllAsTouched();
    }
  }

  hasQBPayDetails(): boolean {
    return !Object.values(this.merchant.accountDetails.qbPayAccountDetails).every(
      (value) => value === null || value === undefined || value === ""
    );
  }

  receiveEditEvent(value: boolean) {
    this.editable = value;
  }
}
